import * as React from "react"
import { Pagination } from "react-bootstrap"

interface TablePaginationProps {
  pageNumber: number
  pages: number
  displayCount?: number
  className?: string
  onChange(pageNumber: number): void
}

const FIRST = "First"
const PREVIOUS = "Previous"
const NEXT = "Next"
const LAST = "Last"

const DisplayCount = 3

export default class TablePagination extends React.PureComponent<TablePaginationProps, {}> {
  pageChanged = (e: React.MouseEvent<HTMLElement>) => {
    const page = (e.target as HTMLElement).innerText
    let pageNumber = 1
    switch (page) {
      case FIRST:
        break
      case PREVIOUS:
        pageNumber = this.props.pageNumber - 1
        break
      case NEXT:
        pageNumber = this.props.pageNumber + 1
        break
      case LAST:
        pageNumber = this.props.pages
        break
      default:
        pageNumber = +page
    }
    if (pageNumber < 1) {
      pageNumber = 1
    }
    if (pageNumber > this.props.pages) {
      pageNumber = this.props.pages
    }

    this.props.onChange(pageNumber)
  }

  getPaginationItem = (label: string, active: boolean, disabled: boolean, onClick: ((e: React.MouseEvent<HTMLElement>) => void)) => {
    return <Pagination.Item
      key={label}
      active={active}
      onClick={!active ? onClick : undefined}
      disabled={disabled}>
      {label}
    </Pagination.Item>
  }

  getPagination = () => {
    let items = []
    const currentPageNumber = this.props.pageNumber
    const displayCount = this.props.displayCount || DisplayCount

    items.push(this.getPaginationItem(FIRST, false, currentPageNumber === 1, this.pageChanged))
    items.push(this.getPaginationItem(PREVIOUS, false, currentPageNumber === 1, this.pageChanged))

    let startIndex
    let endIndex

    if (displayCount === 3) {
      if (this.props.pages <= 3) {
        startIndex = 1
        endIndex = this.props.pages
      } else {
        if (currentPageNumber <= 2) {
          startIndex = 1
          endIndex = 3
        } else if (currentPageNumber + 2 >= this.props.pages) {
          startIndex = this.props.pages - 2
          endIndex = this.props.pages
        } else {
          startIndex = currentPageNumber - 1
          endIndex = currentPageNumber + 1
        }
      }
    } else {
      startIndex = (Math.ceil(currentPageNumber / displayCount) - 1) * displayCount + 1
      endIndex = Math.min(startIndex + displayCount - 1, this.props.pages)
    }

    for (let i = startIndex; i <= endIndex; i++) {
      items.push(this.getPaginationItem(i.toString(), currentPageNumber === i, false, this.pageChanged))
    }

    items.push(this.getPaginationItem(NEXT, false, currentPageNumber === this.props.pages, this.pageChanged))
    items.push(this.getPaginationItem(LAST, false, currentPageNumber === this.props.pages, this.pageChanged))

    return items
  }

  render() {
    if (this.props.pages <= 1) {
      return <></>
    }
    return (<Pagination className={`float-right ${this.props.className || ""}`}>{this.getPagination()}</Pagination>)
  }
}
